import React from 'react';
import { Form, reduxForm, getFormValues } from 'redux-form';
import classNames from 'classnames';

import EditIcon from '@material-ui/icons/Edit';

import {
  Checkbox,
  Button,
  RadioGroup,
  TextField,
  PhoneInput,
  Translation,
} from '../../common';

import { connectTo } from '../../../utils';
import { onClickWrapper } from '../../../utils/ui';
import {
  email as emailValidation,
  mobileNumber as mobileNumberValidation,
} from '../../../utils/validation';
import {
  SMS_FIELD,
  EMAIL_FIELD,
  WHATS_APP_FIELD,
} from '../../../constants/response-channel';

import { ReactComponent as EmailIcon } from '../../../assets/img/contacts/email.svg';
import { ReactComponent as SmsIcon } from '../../../assets/img/contacts/chat.svg';
import { ReactComponent as WhatsappIcon } from '../../../assets/img/contacts/whatsapp.svg';

import phoneTransformer from '../../../utils/phone';
import { DOMAIN_LANGUAGE } from '../../../constants/browser';

class Field extends React.Component {
  state = {
    isEditing: false,
    code: '',
  };

  textfieldRef = React.createRef();

  static getDerivedStateFromProps(nextProps, prevState) {
    return nextProps.disabled && prevState.isEditing
      ? { isEditing: false }
      : null;
  }

  onEditingClick = () => {
    const { isEditing } = this.state;
    if (!isEditing) {
      this.onTextFieldSizeChange();
    }
    this.setState({ isEditing: !isEditing });
  };

  onCodeSelect = (code) => {
    this.setState({ code });
  };

  onMobileKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!/[0-9]/.test(keyValue)) event.preventDefault();
  };

  onTextFieldSizeChange = (
    minLength = 23,
    maxLength = 37,
    minFontSize = 10
  ) => (event) => {
    const { withPhoneInput } = this.props;
    let elem = this.textfieldRef.current;
    if (withPhoneInput) {
      elem = elem.tel;
    }

    if (elem.value.length >= minLength) {
      let initialSize = maxLength - elem.value.length;
      initialSize = initialSize <= minFontSize ? minFontSize : initialSize;
      elem.style.fontSize = initialSize + 'px';
    } else {
      elem.style.fontSize = null;
    }
  };

  onTextFieldBlur = (event) => {
    const elem = this.textfieldRef.current;
    elem.style.fontSize = null;
  };

  render() {
    const {
      styles,
      disabled,
      name,
      onClick,
      invalid,
      header,
      headerIcon: HeaderIcon,
      withPhoneInput,
      formUntouched,
    } = this.props;
    const { isEditing } = this.state;

    return (
      <div
        className={
          styles[
            `response-channel__method-item${
              disabled ? '_disabled' : invalid ? '_invalid' : ''
            }`
          ]
        }
        onClick={onClick(name)}
      >
        <div
          className={classNames(
            styles['response-channel__method-item-header'],
            formUntouched
              ? styles['response-channel__method-item-header_untouched']
              : null
          )}
        >
          {header ? (
            <div className={styles['response-channel__method-item-text']}>
              {header}
            </div>
          ) : null}
          {HeaderIcon ? (
            <HeaderIcon
              className={styles['response-channel__method-item-icon']}
            />
          ) : null}
        </div>
        <div className={styles['response-channel__method-item-input-wrapper']}>
          {withPhoneInput ? (
            <PhoneInput
              inputClassName={classNames(
                styles[
                  `response-channel__method-item-input${
                    disabled ? '_disabled' : !isEditing ? '_selected' : ''
                  }`
                ],
                styles['response-channel__method-item-input_with-flags']
              )}
              name={name}
              preferredCountries={[DOMAIN_LANGUAGE.toLowerCase()]}
              disabled={!isEditing}
              placeholder={!isEditing ? '' : undefined}
              formatOnInit={false}
              ref={this.textfieldRef}
              inputProps={{
                onKeyPress: this.onMobileKeyPress,
                onKeyUp: this.onTextFieldSizeChange(16, 30),
                onFocus: this.onTextFieldSizeChange(16, 30),
                onBlur: this.onTextFieldBlur,
              }}
            />
          ) : (
            <TextField
              name={name}
              className={
                styles[
                  `response-channel__method-item-input${
                    disabled ? '_disabled' : !isEditing ? '_selected' : ''
                  }`
                ]
              }
              disabled={!isEditing}
              ref={this.textfieldRef}
              onKeyUp={this.onTextFieldSizeChange()}
              onFocus={this.onTextFieldSizeChange()}
              onBlur={this.onTextFieldBlur}
              rawInput
            />
          )}
          <span
            className={styles['response-channel__method-item-input-icon']}
            onClick={onClickWrapper(
              'page.postbox.component.response-channel.edit-icon',
              this.onEditingClick
            )}
          >
            <EditIcon />
          </span>
        </div>
      </div>
    );
  }
}

class ResponseChannelForm extends React.Component {
  onTextFieldFocus = (fieldName) => (e) => {
    const { change, values } = this.props;
    if (values.method !== fieldName) {
      change('method', fieldName);
    }
    e.preventDefault();
  };

  isFieldDisabled = (name) => this.props.values.method !== name;
  isFieldInvalid = (name, validationFunc) =>
    !!(!this.isFieldDisabled(name) && validationFunc(this.props.values[name]));

  render() {
    const {
      handleSubmit,
      onSubmit,
      styles,
      values,
      isFileLoading,
      withWhatsapp,
    } = this.props;

    const emailDisabled = this.isFieldDisabled(EMAIL_FIELD);
    const smsDisabled = this.isFieldDisabled(SMS_FIELD);
    const whatsAppDisabled = this.isFieldDisabled(WHATS_APP_FIELD);

    const formUntouched = emailDisabled && smsDisabled && whatsAppDisabled;

    const invalidEmail = !!(
      !emailDisabled && emailValidation(this.props.values[EMAIL_FIELD])
    );
    const invalidSms = !!(
      !smsDisabled &&
      mobileNumberValidation(
        this.props.values[SMS_FIELD] &&
          this.props.values[SMS_FIELD].country &&
          this.props.values[SMS_FIELD].country.code
      )(
        (this.props.values[SMS_FIELD] && this.props.values[SMS_FIELD].value) ||
          '',
        true
      )
    );
    const invalidWhatsapp = !!(
      !this.isFieldDisabled(WHATS_APP_FIELD) &&
      mobileNumberValidation(
        this.props.values[WHATS_APP_FIELD] &&
          this.props.values[WHATS_APP_FIELD].country &&
          this.props.values[WHATS_APP_FIELD].country.code
      )(
        (this.props.values[WHATS_APP_FIELD] &&
          this.props.values[WHATS_APP_FIELD].value) ||
          ''
      )
    );

    const isFormInvalid =
      !values.method ||
      invalidEmail ||
      invalidSms ||
      invalidWhatsapp ||
      isFileLoading;

    return (
      <Form
        onSubmit={handleSubmit(({ remember, method, [method]: value }) =>
          onSubmit({
            remember: !!remember,
            method,
            value:
              method === SMS_FIELD || method === WHATS_APP_FIELD
                ? phoneTransformer(value.value, value.country.code, true)[0]
                : value,
          })
        )}
        className={styles['response-channel']}
      >
        <h1 className={styles['response-channel__header']}>
          <Translation>{'RESPONSE_CHANNEL_HEADER'}</Translation>
        </h1>
        <div className={styles['response-channel__description']}>
          <Translation>{'RESPONSE_CHANNEL_DESCRIPTION'}</Translation>
        </div>
        <RadioGroup
          name="method"
          options={[
            {
              label: (
                <Field
                  styles={styles}
                  disabled={emailDisabled}
                  formUntouched={formUntouched}
                  name={EMAIL_FIELD}
                  onClick={this.onTextFieldFocus}
                  invalid={invalidEmail}
                  header="E-Mail"
                  headerIcon={EmailIcon}
                />
              ),
              value: EMAIL_FIELD,
              id: 'page.postbox.component.response-channel-radiogroup.email',
            },
            {
              label: (
                <Field
                  styles={styles}
                  disabled={smsDisabled}
                  formUntouched={formUntouched}
                  name={SMS_FIELD}
                  onClick={this.onTextFieldFocus}
                  invalid={invalidSms}
                  header="SMS"
                  headerIcon={SmsIcon}
                  withPhoneInput
                />
              ),
              value: SMS_FIELD,
              id: 'page.postbox.component.response-channel-radiogroup.sms',
            },
            withWhatsapp && {
              label: (
                <Field
                  styles={styles}
                  disabled={whatsAppDisabled}
                  formUntouched={formUntouched}
                  name={WHATS_APP_FIELD}
                  onClick={this.onTextFieldFocus}
                  currentValue={values[WHATS_APP_FIELD]}
                  invalid={invalidWhatsapp}
                  header="Whatsapp"
                  headerIcon={WhatsappIcon}
                  withPhoneInput
                />
              ),
              value: WHATS_APP_FIELD,
              id: 'page.postbox.component.response-channel-radiogroup.whatsapp',
            },
          ].filter((value) => !!value)}
          radioClassName={styles['response-channel__method-item-wrapper']}
          radioLabelClassName={
            styles['response-channel__method-item-radio-label']
          }
          radioIconCheckedClassName={
            styles['response-channel__method-item-radio-icon']
          }
        />
        {isFormInvalid ? (
          <div className={styles['response-channel__invalid']}>
            {invalidEmail ? (
              <Translation>{'RESPONSE_CHANNEL_NEW_EMAIL'}</Translation>
            ) : invalidSms || invalidWhatsapp ? (
              <Translation>{'RESPONSE_CHANNEL_NEW_PHONE'}</Translation>
            ) : (
              ''
            )}
          </div>
        ) : null}
        <div className={styles['response-channel__save-changes-wrapper']}>
          <Button
            id="page.postbox.component.response-channel.save-button"
            className={
              styles[
                `response-channel__save-changes-button${
                  isFormInvalid ? '_disabled' : ''
                }`
              ]
            }
            type="submit"
            disabled={isFormInvalid}
          >
            <Translation>RESPONSE_CHANNEL_CONFIRM</Translation>
          </Button>
          <div className={styles['response-channel__remember-wrapper']}>
            <Checkbox
              id="page.postbox.component.response-channel.remember-checkbox"
              classNameLabel={styles['response-channel__remember']}
              classNameChecked={styles['response-channel__remember_checked']}
              name="remember"
              label="RESPONSE_CHANNEL_REMEMBER"
              translated
            />
          </div>
        </div>
      </Form>
    );
  }
}

const FORM_NAME = 'response-channel';

const connected = connectTo(
  (state) => ({
    values: getFormValues(FORM_NAME)(state),
  }),
  {},
  ResponseChannelForm
);

export default reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
})(connected);
